import { EFeatureKey } from "@app/shared/payment/enums/feature-key.enum";

const USAGE_LIMITED_FEATURES = new Set([EFeatureKey.CREDIT]);

export function isFeatureUsageLimited(key: EFeatureKey) {
  return USAGE_LIMITED_FEATURES.has(key);
}
